module.exports = __webpack_public_path__ + "img/3.2019cc17.png";